export const RoleSelect = {
  extends: 'SelectField',
  // THE FIELD LAW (admin audit 2026-09-24, /admin/teams invite row): a field
  // is a `controlH` control. The root read min-height auto (44px only by the
  // inner select's own floor); the floor is declared here, so it holds
  // whatever the inner select does.
  minHeight: 'controlH',
  padding: '0',
  round: 'radiusPill',
  Select: {
    // No hard-coded name or id: the brand SelectField gives each select its
    // own id (3.14.796); the literal 'user' repeated on every instance.
    onChange: async (ev, el, s) => {
      ev.preventDefault()
      ev.stopImmediatePropagation()
      const res = window.confirm('Do you really want to change the User Role for this Project?')
      if (res) {
        try {
          const rs = el.getRootState()
          await el.sdk.updateMemberRole(rs.projectId, s.id, ev.target.value)
        } catch (err) {
          console.error(err)
        }
      } else {
        ev.target.value = s.role
      }
    },
    childrenAs: 'props',
    children: () => [
      {
        value: 'owner',
        text: '{{ members.role.owner | polyglot }}'
      },
      {
        value: 'admin',
        text: '{{ members.role.admin | polyglot }}'
      },
      {
        value: 'editor',
        text: '{{ members.role.editor | polyglot }}'
      },
      {
        value: 'guest',
        text: '{{ members.role.guest | polyglot }}'
      }
    ],
    childProps: {
      tag: 'option',
      attr: {
        disabled: (el, s) => !el.hasProjectPermission('iam'),
        selected: (el, s) => {
          const userRole = s.role || -1
          const optionValue = el.value
          return userRole === optionValue
        }
      }
    }
  }
}
